import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SessionHandler() {
    const location =useLocation();

    useEffect(()=>{
        if(!location.pathname.includes("/edit")){
            sessionStorage.removeItem("pageContentId");
        }
    },[location]);
    return null;
}